"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACAutoCompleteInput = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var react_1 = require("react");
var utils_1 = require("../utils");
var ACWrapperContext_1 = require("./ACWrapperContext");
var FormInputLabel_1 = __importDefault(require("./FormInputLabel"));
// import '../styles/index.css';
var truncateTextByWords = function (text, wordLimit) {
    if (!text)
        return ''; // Return empty string if text is empty or undefined
    if (typeof text !== 'string')
        return text; // Return as is if not a string
    var wordsArray = text.split(' '); // Split the text into words
    if (wordsArray.length <= wordLimit) {
        return text; // If the number of words is less than or equal to the limit, return the original text
    }
    return wordsArray.slice(0, wordLimit).join(' ') + '...'; // Truncate and add ellipsis
};
var renderItem = function (item, props, index, wordLimit) {
    if (wordLimit === void 0) { wordLimit = 18; }
    if (typeof item.label !== 'string') {
        return item;
    }
    // const { label, contact, index } = item;
    var value = (item === null || item === void 0 ? void 0 : item[props.optionLabelKey || 'value']) || '';
    var label = (item === null || item === void 0 ? void 0 : item[props.optionValueKey || 'value']) || '';
    var truncatedLabel = label ? truncateTextByWords(label, wordLimit) : '';
    return __assign(__assign({}, item), { key: item.key || index, value: item.key || index, labelText: label || ' ', valueText: value || '', label: props.optionVariant !== 'user' ? ((0, jsx_runtime_1.jsxs)(antd_1.Flex, { align: "center", justify: "space-between", children: [value, (0, jsx_runtime_1.jsx)(antd_1.Typography.Text, { ellipsis: true, children: truncatedLabel })] })) : (renderUserVariant(truncatedLabel, value)) });
};
var renderUserVariant = function (label, value, newOption) {
    if (newOption === void 0) { newOption = false; }
    var name = label === null || label === void 0 ? void 0 : label.trim();
    var getInitial = function (label) {
        return typeof label === 'string' && label.trim().length > 0
            ? label.trim().charAt(0).toUpperCase()
            : null;
    };
    var avatarColors = [
        'bg-red-700',
        'bg-blue-700',
        'bg-green-700',
        'bg-yellow-700',
        'bg-purple-700',
        'bg-pink-700',
        'bg-indigo-700',
        'bg-teal-700',
        'bg-orange-700',
        'bg-rose-700',
        'bg-emerald-700',
    ];
    var getAvatarColor = function (name) {
        if (name === void 0) { name = ''; }
        var hash = name
            .split('')
            .reduce(function (acc, char) { return acc + char.charCodeAt(0); }, 0);
        return avatarColors[hash % avatarColors.length];
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex gap-2 items-center", children: [newOption ? ((0, jsx_runtime_1.jsx)("div", { className: "flex-shrink-0 !size-[35px] bg-primary/5 rounded-full d-center", children: (0, jsx_runtime_1.jsx)("i", { className: "aci aci-add text-primary" }) })) : ((0, jsx_runtime_1.jsx)(antd_1.Avatar, { className: "flex-shrink-0 !size-[35px] ".concat(name ? getAvatarColor(name) : 'bg-gray-400'), children: getInitial(name) || 'U' })), (0, jsx_runtime_1.jsxs)("div", { className: "min-w-0", children: [(0, jsx_runtime_1.jsx)("div", { className: "font-semibold truncate", children: name || 'Unknown' }), (0, jsx_runtime_1.jsx)("div", { className: "text-xs text-gray-500 truncate", children: value })] })] }));
};
var ACAutoCompleteInput = function (props) {
    var _a = (0, react_1.useState)(props.items &&
        props.items.map(function (item, index) { return renderItem(item, props, index); })), options = _a[0], setOptions = _a[1];
    var _b = (0, react_1.useState)(props.value || ''), searchText = _b[0], setSearchText = _b[1];
    var _c = (0, react_1.useState)(''), debouncedSearchText = _c[0], setDebouncedSearchText = _c[1];
    // const [value, setValue] = useState<autoCompleteProps>();
    var _d = (0, react_1.useState)(false), dropdownVisible = _d[0], setDropdownVisible = _d[1];
    var debounceTimeoutRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        setSearchText(props.value === ' ' ? '' : props.value || '');
    }, [props.value]);
    (0, react_1.useEffect)(function () {
        // Clear any existing timeout
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }
        // Set new timeout (300ms is a common debounce delay)
        debounceTimeoutRef.current = setTimeout(function () {
            setDebouncedSearchText(searchText);
        }, 300);
        // Cleanup function
        return function () {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, [searchText]);
    (0, react_1.useEffect)(function () {
        var _a = props.endPoint, endpoint = _a === void 0 ? '' : _a, _b = props.function, functionName = _b === void 0 ? '' : _b;
        if (endpoint) {
            var ParentUtils = (0, ACWrapperContext_1.getUtils)();
            var finalEndpoint = utils_1.Utils.getProcessedEndpoint({
                params: __assign(__assign({}, props === null || props === void 0 ? void 0 : props.params), { searchText: debouncedSearchText }),
                endPoint: endpoint,
                rootState: props.rootState,
            });
            var func_1 = ParentUtils[functionName] || ParentUtils.makeApiCall;
            finalEndpoint.then(function (endpoint) {
                func_1(endpoint, 'GET').then(function (apiResult) {
                    var _a, _b;
                    var _c;
                    var finalOptions = [];
                    if (((_c = apiResult.data) === null || _c === void 0 ? void 0 : _c.length) !== 0) {
                        if (props.alwaysShowCustomOption && debouncedSearchText) {
                            // If alwaysShowCustomOption is true, add the custom option
                            var customOption = (_a = {
                                    key: 'custom_option',
                                    value: 'custom_option',
                                    labelText: props.customOptionLabel || 'Add New',
                                    valueText: debouncedSearchText
                                },
                                _a[props.additionalKeyName || 'value'] = debouncedSearchText,
                                _a.label = props.optionVariant !== 'user' ? ((0, jsx_runtime_1.jsxs)(antd_1.Flex, { align: "center", justify: "space-between", children: [debouncedSearchText, (0, jsx_runtime_1.jsx)(antd_1.Typography.Text, { children: props.customOptionLabel || 'Add New' })] })) : (renderUserVariant(props.customOptionLabel || 'Add New', debouncedSearchText, true)),
                                _a);
                            finalOptions = __spreadArray(__spreadArray([], apiResult.data, true), [customOption], false);
                        }
                        else {
                            finalOptions = apiResult.data;
                        }
                        setOptions(finalOptions.map(function (item, index) {
                            return renderItem(item, props, index);
                        }));
                    }
                    else {
                        if (props.allowAddNew && debouncedSearchText) {
                            // If no options and allowAddNew is true, show the custom option
                            setOptions([
                                (_b = {
                                        key: 'custom_option',
                                        value: 'custom_option',
                                        labelText: props.customOptionLabel || 'Add New',
                                        valueText: debouncedSearchText
                                    },
                                    _b[props.additionalKeyName || 'value'] = debouncedSearchText,
                                    _b.label = props.optionVariant !== 'user' ? ((0, jsx_runtime_1.jsxs)(antd_1.Flex, { align: "center", justify: "space-between", children: [debouncedSearchText, (0, jsx_runtime_1.jsx)(antd_1.Typography.Text, { children: props.customOptionLabel || 'Add New' })] })) : (renderUserVariant(props.customOptionLabel || 'Add New', debouncedSearchText, true)),
                                    _b),
                            ]);
                            setDropdownVisible(true);
                        }
                    }
                });
            });
        }
    }, [debouncedSearchText]);
    var onSearch = function (searchText) {
        setSearchText(searchText);
        if (props.onChange) {
            props.onChange(searchText);
        }
        if (searchText) {
            setDropdownVisible(true); // This is the key fix
        }
        else {
            setDropdownVisible(false);
        }
        // Update searchText and show dropdown for non-empty valid input
    };
    var onSelect = function (value, option) {
        if (props.onSelect) {
            var newOption = __assign(__assign({}, option), { key: option.key, value: option.valueText, text: option.labelText });
            setSearchText(option.valueText);
            props.onSelect(newOption);
        }
        setDropdownVisible(false);
    };
    // console.log('options', options);
    // Handle keydown for numeric input validation
    var handleKeyDown = function (e) {
        if (props.inputType === 'number') {
            // Allow: backspace, delete, tab, escape, enter, arrows, home, end etc.
            var allowedKeys = [
                'Backspace',
                'Delete',
                'Tab',
                'Escape',
                'Enter',
                'ArrowLeft',
                'ArrowRight',
                'ArrowUp',
                'ArrowDown',
                'Home',
                'End',
            ];
            // Allow Ctrl/Cmd+A/C/X/Z for text operations
            if ((e.ctrlKey || e.metaKey) &&
                ['a', 'c', 'x', 'z'].includes(e.key.toLowerCase())) {
                return;
            }
            // Handle paste specially
            if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'v') {
                // We'll let the paste happen, but handle it in our handlePaste function
                return;
            }
            // Allow navigation keys
            if (allowedKeys.includes(e.key)) {
                return;
            }
            // Prevent non-digit keys
            if (!/^\d$/.test(e.key)) {
                e.preventDefault();
            }
        }
    };
    // Handle paste event to filter out non-numeric characters
    // const handlePaste = (e: React.ClipboardEvent<HTMLDivElement>) => {
    //   if (props.inputType === 'number') {
    //     // Get pasted content
    //     const clipboardData = e.clipboardData || (window as any).clipboardData;
    //     const pastedData = clipboardData.getData('Text');
    //     // Filter non-numeric characters
    //     if (!/^\d*$/.test(pastedData)) {
    //       // If there are non-numeric characters, prevent default paste
    //       e.preventDefault();
    //       // Extract only the numeric part
    //       const numericPart = pastedData.replace(/\D/g, '');
    //       // If we have numeric parts, manually update with cleaned data
    //       if (numericPart) {
    //         // Get the current value
    //         const currentValue = value?.value || '';
    //         const newValue = currentValue + numericPart;
    //         // Update with the cleaned numeric value
    //         const newOption = { key: newValue, value: newValue };
    //         setValue(newOption as autoCompleteProps);
    //         setSearchText(newValue);
    //         if (props.onChange) {
    //           props.onChange(newOption);
    //         }
    //       }
    //     }
    //   }
    // };
    return ((0, jsx_runtime_1.jsxs)("div", { className: props.containerClassName, children: [(0, jsx_runtime_1.jsx)(FormInputLabel_1.default, __assign({}, props)), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(antd_1.AutoComplete, { placeholder: props.placeholder, allowClear: props.allowClear, id: props.name, options: options, disabled: props.disabled, status: props.required && props.errorText ? 'error' : '', className: "".concat('apx-ui_select', " ").concat((props === null || props === void 0 ? void 0 : props.color) || 'primary', " ").concat(props.className), 
                    // onChange={handleChange}
                    onSearch: onSearch, onSelect: onSelect, value: searchText, open: dropdownVisible && options && options.length > 0, onBlur: function () { return setTimeout(function () { return setDropdownVisible(false); }, 200); }, onFocus: function () {
                        return options && options.length > 0 && setDropdownVisible(true);
                    }, onKeyDown: handleKeyDown, 
                    // filterOption={props.options ? true : (inputValue, option) => {
                    //   // If searching is disabled, just return everything
                    //   if (!props.allowSearch) {
                    //     return true;
                    //   }
                    //   // Return false if option is undefined
                    //   if (!option) {
                    //     return false;
                    //   }
                    //   if (props.inputType === 'number') {
                    //     return option.valueText === inputValue;
                    //   }
                    //   // For text inputs, use contains matching (case insensitive)
                    //   return option.valueText?.toLowerCase().includes(inputValue.toLowerCase()) || false;
                    // }}
                    filterOption: props.endPoint
                        ? false
                        : function (inputValue, option) {
                            var _a;
                            return (((_a = option === null || option === void 0 ? void 0 : option[(props === null || props === void 0 ? void 0 : props.filterKey) || 'value']) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(inputValue.toLowerCase())) || false);
                        } }) }), props.required ? ((0, jsx_runtime_1.jsx)("p", { className: props.errorClassName, children: props.errorText && props.errorText })) : null] }));
};
exports.ACAutoCompleteInput = ACAutoCompleteInput;
